import { useEffect, useRef, useState } from "react";
import AssignUserTerminalToSubOrg from "./AssignUserTerminalToSubOrg";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Autocomplete, Box, Button, Dialog, Divider, FormControlLabel, Grid, InputAdornment, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, MenuItem, Switch } from "@mui/material";
import { Pagination } from "../../Pagination";
import './UserTerminals.css';
import { checkLoggedInUserAuthorizedToViewPage, getDecodeURI, getEncodedURI, getDataFromLocalStorageParsed, useAuthorization } from '../../../utils/util';
import { getUserTerminals, clearComponentData, removeTerminalAPI, ACTION_TYPES } from "../slice";
import SortArrows, { SortOrder } from "../../SortArrows";
import { UserTerminal } from "../types";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import { CsvParameters, downloadAsCSV } from "../../../actions/Users/authenticateCsvDownload";
import Download from '../../../asset/image/DownloadUsage.svg';
import DownloadCSV, { clearCsvDownload } from "../../DownloadCSV";
import DeleteIcon from "../../../asset/image/deleteEnabled.svg";
import DisabledeleteIcon from "../../../asset/image/deleteDisabled.svg";
import { getAllServiceLines } from "../../StarlinkReports/slice";
import _ from "lodash";
import CreateServiceLineDialog from "../CreateServiceLineDialog";
import AddStarlink from "./AddStarlink";
import { toast } from "react-toastify";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
import DeleteWANProfileModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/DeleteProfileModal";
const convertToCsv = (data: any[][]) => {
    const csvRows: any[] = [];
    data.forEach((row) => {
        csvRows.push([row[5], row[2], row[0], row[8].replaceAll(',', ';'), row[9].replaceAll(',', ';'), row[7], row[6], row[12]])
    })
    return [['Organization', 'Sub Organization', 'ACCOUNT NUMBER', 'Serial Number', 'KIT Number', 'Service Line Name', 'Service Line Number', 'K4 Site'], ...csvRows]
}

interface UserTerminalsProps {
    authReducer: any;
    errorReducer: any;
    history: any;
    location: any;
    dpIds: string[];
    userTerminals: any[];
    totalUserTerminals: number;
    getUserTerminals: (parameters: any) => void;
    clearComponentData: () => void;
    downloadAsCSV: (parameters: any) => void;
    updateUserTerminalOrganization: (parameters: any) => void;
    newSummaryServiceLine: any;
    serviceLines: any;
    getAllServiceLines: (parameters: any) => void;
    starlinkCloud: any;
    selectedServiceAccount: any;
    removeTerminalAPI: (parameters: any) => void;
    removeUserTerminal: any;
    hasUserChangedServiceLine: boolean;
    newSummaryServiceAccount: any;
}

export type UserTerminalSortBy = 'serviceLineName' | 'userTerminalId' | 'kitSerialNumber' | 'dishSerialNumber' | 'k4SiteName' | 'accountDpName' | 'dpName';

function UserTerminals(props: UserTerminalsProps) {

    const { authReducer, history, location, dpIds, userTerminals, serviceLines, hasUserChangedServiceLine, newSummaryServiceAccount, starlinkCloud, totalUserTerminals, selectedServiceAccount, removeUserTerminal, getUserTerminals, removeTerminalAPI, clearComponentData, downloadAsCSV, newSummaryServiceLine, getAllServiceLines } = props;

    const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const [searchText, setSearchText] = useState<string>(queryParams.get('search') || '');
    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        sortBy: UserTerminalSortBy;
        sortOrder: SortOrder;
        search: string;
        terminalStatus: string[];
    }>({
        page: queryParams.has('page') ? parseInt(queryParams.get('page') as string) : 1,
        size: queryParams.has('size') ? parseInt(queryParams.get('size') as string) : 10,
        sortBy: queryParams.has('sortBy') ? queryParams.get('sortBy') as UserTerminalSortBy : 'userTerminalId',
        sortOrder: queryParams.has('sortOrder') ? queryParams.get('sortOrder') as SortOrder : 'asc',
        search: queryParams.has('search') ? queryParams.get('search') as string : '',
        terminalStatus: queryParams.has('terminalStatus') ? queryParams.get('terminalStatus')?.split(',') as string[] : ['deployed']
    });
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
    const [openCreateServiceLineDialog, setOpenCreateServiceLineDialog] = useState<boolean>(false);
    const searchTimeoutRef = useRef<any>();
    const dispatch = useDispatch();
    const [openStarlinkPopup, setOpenStarlinkPopup] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [terminalToDelete, setTerminalToDelete] = useState<any>(null)
    const isAllServiceLineUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.allServiceLineUser;
    const [effectiveServiceLines, setEffectiveServiceLines] = useState<any[] | "''" | null>(null);
    const { isAdmin } = useAuthorization();
    const [openAssignUT, setOpenAssignUT] = useState(false)

    const handleOnSearchClick = () => {
        handleSearch(searchText);
    }

    const handleOnSearchClear = () => {
        setSearchText('');
        handleSearch('');
    }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchText(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }

    const handleSearch = (value: string) => {
        setTableParams({
            ...tableParams,
            search: value,
            page: 1
        });
    }

    const handleChangePage = (event: any, newPage: number) => {
        setTableParams({ ...tableParams, page: newPage });
    };

    const handleChangeSize = (event: any) => {
        setTableParams({ ...tableParams, size: event.target.value, page: 1 });
    };

    const handleChangeSorting = (sortBy: UserTerminalSortBy, sortOrder: SortOrder) => {
        setTableParams({
            ...tableParams,
            sortBy: sortBy,
            sortOrder: sortOrder,
            page: 1
        });
    }

    const handleChangeTerminalStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        let _terminalStatus = ['deployed', 'in-warehouse'];
        if (event.target.value === 'deployed') {
            _terminalStatus = ['deployed'];
        } else if (event.target.value === 'in-warehouse') {
            _terminalStatus = ['in-warehouse'];
        }
        setTableParams({
            ...tableParams,
            terminalStatus: _terminalStatus,
            page: 1
        });
    };

    const updateQueryParams = () => {
        queryParams.set('page', tableParams.page.toString())
        queryParams.set('size', tableParams.size.toString())
        queryParams.set('sortBy', tableParams.sortBy)
        queryParams.set('sortOrder', tableParams.sortOrder)
        queryParams.set('search', tableParams.search)
        queryParams.set('terminalStatus', tableParams.terminalStatus.join(','))
        history.replace({ pathname: location.pathname, search: `?${getEncodedURI(Object.fromEntries(queryParams.entries()))}` });
    }

    useEffect(() => {
        if (isAllServiceLineUser && !hasUserChangedServiceLine) {
            setEffectiveServiceLines("''");
            return;
        }

        if (isAllServiceLineUser && hasUserChangedServiceLine) {
            if (Array.isArray(newSummaryServiceLine) && newSummaryServiceLine.length > 0) {
                setEffectiveServiceLines(newSummaryServiceLine);
            }
            return;
        }

        if (Array.isArray(newSummaryServiceLine)) {
            setEffectiveServiceLines(newSummaryServiceLine);
        }

    }, [isAllServiceLineUser,JSON.stringify(newSummaryServiceLine)]);

    useEffect(() => {
        if (_.isEmpty(tableParams)) return;
        if (effectiveServiceLines === null) return;
        updateQueryParams();
        clearComponentData();
        getUserTerminals({
            dpIds,
            accounts: effectiveServiceLines === "''" && newSummaryServiceAccount?.length === selectedServiceAccount?.length ? [] : selectedServiceAccount,
            searchText: tableParams.search,
            sortBy: tableParams.sortBy,
            sortOrder: tableParams.sortOrder,
            page: tableParams.page,
            limit: tableParams.size,
            terminalStatus: tableParams.terminalStatus,
            serviceLines: tableParams.terminalStatus.includes('in-warehouse') ? ['<NOT_CONFIGURED>'] : effectiveServiceLines === "''" || effectiveServiceLines === null ? [] : effectiveServiceLines ,
        });

        getAllServiceLines({ serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [] });
    },
    [JSON.stringify(tableParams),  effectiveServiceLines,  JSON.stringify(selectedServiceAccount)]);

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'user-terminal') {
                const data = authReducer.csvDataDownloded;
                if (data === null) {
                    return;
                }
                if (data && data.length > 0) {
                    const keys = ['accountNumber', 'dpId', 'k4SiteName', 'dpName', 'accountDpId', 'accountDpName', 'serviceLineNumber', 'serviceLineName', 'userTerminalId', 'kitSerialNumber', 'dishSerialNumber', 'terminalStatus', 'k4DeviceId', 'k4SiteId', 'total_count'];

                    const arrayOfObjects = data.map((data, rowIndex) => {
                        if (rowIndex === 0) return null;
                        const obj = {};
                        keys.forEach((key, index) => {
                            obj[key] = data[index];
                        });
                        return obj;
                    }).filter(obj => obj !== null);
                    if (arrayOfObjects.length) {
                        DownloadCSV(convertToCsv([...arrayOfObjects.map(row => Object.values(row))]), {
                            formatters: {
                                0: 'ESC-COMMA',
                                1: 'ESC-COMMA',
                                5: 'ESC-COMMA',
                                6: 'ESC-COMMA'
                            }
                        });
                    }
                }
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: 'QUERY_CH',
            id: 'user-terminal',
            payload: {
                dpIds: dpIds?.map(dpId => `'${dpId}'`).join(','),
                accountNumbers: effectiveServiceLines === "''" && newSummaryServiceAccount?.length === selectedServiceAccount?.length ? "''" : selectedServiceAccount?.map(acc => `'${acc}'`).join(','),
                sortBy: tableParams.sortBy,
                sortOrder: tableParams.sortOrder,
                limit: totalUserTerminals,
                offset: 0,
                searchText: '',
                terminalStatus: tableParams.terminalStatus.map(status => `'${status}'`).join(','),
                serviceLines: tableParams.terminalStatus.includes('in-warehouse') ? "'<NOT_CONFIGURED>'" : effectiveServiceLines === "''" || effectiveServiceLines === null ? "''" : effectiveServiceLines?.map(sl => `'${sl}'`).join(','),

            },
            queryName: 'OPT_GET_USER_TERMINALS_ADMIN',
        }
        downloadAsCSV(params);
    }

    const options = serviceLines.length > 0
        ? [{ serviceLineNumber: '', nickname: 'Create New Service Line' }, ...serviceLines]
        : [];


    const removeTerminal = () => {
        setConfirmDelete(false)
        let params = {
            organizationId: authReducer?.selectedOu?.id,
            accountNumber: terminalToDelete?.accountNumber,
            userTerminalId: terminalToDelete?.kitSerialNumber
        }

        removeTerminalAPI(params)
    }

    useEffect(() => {
        if (!_.isEmpty(removeUserTerminal)) {
            toast.success(` ${removeUserTerminal?.message}`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setTerminalToDelete(null)
            setConfirmDelete(false)
            dispatch({ type: ACTION_TYPES?.REMOVE_USER_TERMINAL, payload: {} })
        }

    }, [removeUserTerminal])


    return (
        <Paper elevation={1} classes={{ root: 'starlink--base--mtb_07x starlink--base--padding_1x add-srcoll-starlink-subtab-pages' }}>
            {/* FILTERS */}
            <Grid classes={{ root: 'starlink--base--mtb_07x starlink--base--flex--align--center starlink--base--flex--justify--space_between' }}>
                <Grid>
                    <Typography component="div" classes={{ root: 'starlink--base--font_1x' }}>
                        USER TERMINALS
                    </Typography>
                </Grid>
                <Grid classes={{ root: 'starlink--base--flex starlink--base--flex--align--center' }}>
                    <RadioGroup
                        row
                        aria-labelledby="starlink--service_account_type--radio_group"
                        name="controlled-radio-buttons-group"
                        value={tableParams.terminalStatus.length === 2 ? 'all' : tableParams.terminalStatus[0]}
                        onChange={handleChangeTerminalStatus}
                    >
                        {/* <FormControlLabel value="all" control={<Radio size="small" />} label="All" /> */}
                        <FormControlLabel value="deployed" control={<Radio size="small" />} label="Deployed" />
                        <FormControlLabel disabled={!isAdmin} value="in-warehouse" control={<Radio size="small" />} label="Warehouse" />
                    </RadioGroup>
                    <Button variant="contained" className='starlink--button_contained--primary' disabled={!isAdmin} onClick={() => { setOpenStarlinkPopup(true) }} >Add Starlink</Button>
                    {tableParams?.terminalStatus?.includes("in-warehouse") &&<Button variant="contained" className='starlink--button_contained--primary' disabled={!isAdmin} onClick={() => { setOpenAssignUT(true) }} >Assign</Button>}
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="search"
                                variant="outlined"
                                placeholder="Type something"
                                autoComplete="off"
                                classes={{ root: "input-box-user-ter" }}
                                size="small"
                                value={searchText}
                                onChange={handleOnSearchChange}
                                onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                                InputLabelProps={{ className: "serachLabel" }}
                                InputProps={{
                                    className: "serachBar",
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            {!searchText && <SearchIcon
                                                className="cursorPointer input-search-icons" onClick={handleOnSearchClick}
                                            />}
                                            {searchText && <CloseIcon
                                                className="cursorPointer input-search-icons"
                                                onClick={handleOnSearchClear}
                                            />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </Grid>
                    {totalUserTerminals > 0 && <div className="download-summary-btn" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>}
                </Grid>
            </Grid>

            <Pagination count={totalUserTerminals} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} />

            <TableContainer component={Paper} className="starlink--table_container">
                <Table sx={{ minWidth: 650 }} size="small" aria-label="starlink--service_accounts">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="accountDpName" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">ORGANIZATION</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="dpName" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">SUB ORGANIZATION</span>
                                </SortArrows>
                            </TableCell>
                            {/* <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="userTerminalId" onChange={handleChangeSorting}>
                                <span className="font-wt-900">STARLINK ID</span>
                                </SortArrows>
                            </TableCell>*/}
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="dishSerialNumber" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">ACCOUNT NUMBER</span>
                                </SortArrows>
                            </TableCell>
                            {tableParams.terminalStatus?.includes("deployed") &&
                                <TableCell>
                                    <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="serviceLineName" onChange={handleChangeSorting}>
                                        <div className="starlink-user-terminal-service-line-toggle">
                                            <span className="font-wt-900">SERVICE LINE</span>
                                            <div
                                                onClick={(e) => e.stopPropagation()}
                                                onMouseDown={(e) => e.stopPropagation()} >
                                                <Tooltip title="SL Name / SL Number">
                                                    <Switch size="small"
                                                        checked={switchServiceLineToggle}
                                                        onChange={(e) => { e.stopPropagation(); setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </SortArrows>
                                </TableCell>}
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="kitSerialNumber" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">KIT NUMBER</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                    <span className="font-wt-900">DISH SERIAL</span>
                            </TableCell>
                            {tableParams.terminalStatus?.includes("deployed") &&
                                <TableCell>
                                    <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="k4SiteName" onChange={handleChangeSorting}>
                                        <span className="font-wt-900">K4 SITE</span>
                                    </SortArrows>
                                </TableCell>}
                            {tableParams.terminalStatus?.includes("in-warehouse") &&
                                <TableCell>
                                    <span className="font-wt-900">Actions</span>
                                </TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            userTerminals?.length > 0 ? userTerminals.map((userTerminal: UserTerminal) => {
                                return <TableRow
                                    key={userTerminal.userTerminalId}
                                >
                                    <TableCell>
                                        {userTerminal.accountDpName}
                                    </TableCell>
                                    <TableCell>
                                        {userTerminal.dpName}
                                    </TableCell>

                                    <TableCell>
                                        <Tooltip
                                            classes={{ tooltip: 'starlink--tooltip' }}
                                            title={
                                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                    <Table size="small">
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>ACCOUNT NAME</TableCell>
                                                                <TableCell>   {userTerminal.accountName}</TableCell>
                                                            </TableRow>

                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            }
                                        >
                                            <span> {userTerminal?.accountNumber}</span>
                                        </Tooltip>
                                    </TableCell>
                                    {tableParams.terminalStatus?.includes("deployed") && <TableCell>
                                        {switchServiceLineToggle ? userTerminal?.serviceLineNumber : userTerminal?.serviceLineName}
                                    </TableCell>}
                                    <TableCell>
                                        <Tooltip
                                            classes={{ tooltip: 'starlink--tooltip' }}
                                            title={
                                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                    <Table size="small">
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Starlink ID</TableCell>
                                                                <TableCell>{userTerminal.userTerminalId}</TableCell>
                                                            </TableRow>

                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            }
                                        >
                                            <span>{userTerminal.kitSerialNumber}</span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                            <span>{userTerminal.dishSerialNumber}</span>
                                    </TableCell>
                                    {tableParams.terminalStatus?.includes("deployed") &&<TableCell> {userTerminal.k4SiteName} </TableCell> }
                                     {tableParams.terminalStatus?.includes("in-warehouse") &&  userTerminal?.serviceLineNumber === "<NOT_CONFIGURED>" &&
                                    <TableCell>
                                        <Tooltip title="Delete KIT from Account">
                                            <img src={!isAdmin ? DisabledeleteIcon : DeleteIcon}
                                                onClick={(e) => { setConfirmDelete(true); setTerminalToDelete(userTerminal) }}
                                                className="starlink-delete-icon-enabled" />
                                        </Tooltip>
                                    </TableCell>
                                    }
                                </TableRow>

                            }) : <TableRow>
                                <TableCell colSpan={8} align='center'>
                                    No data available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <CreateServiceLineDialog open={openCreateServiceLineDialog} onClose={() => { setOpenCreateServiceLineDialog(false) }} onSave={() => { }} />
            <AddStarlink open={openStarlinkPopup} onClose={() => { setOpenStarlinkPopup(false) }} />
            <AssignUserTerminalToSubOrg open={openAssignUT} setOpen={setOpenAssignUT} />
            <DeleteWANProfileModal
                    open={confirmDelete}
                    onClose={()=>{setConfirmDelete(false); setTerminalToDelete(null)}}
                    onConfirm={()=>{removeTerminal()}}
                    title={"Remove"}
                    confirmText = {"Remove"}
                    entityLabel={`Are you sure you want to remove starlink ${terminalToDelete?.kitSerialNumber} ?`}
                    entityName=""
                    errorMessage={"This will remove starlink from this account."}
                    />

        </Paper>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud.dpIds,
    userTerminals: state.starlinkAdmin.userTerminals,
    removeUserTerminal: state.starlinkAdmin.removeUserTerminal,
    totalUserTerminals: state.starlinkAdmin.totalUserTerminals,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
    serviceLines: state.starlinkReports.allServiceLines,
    starlinkCloud: state.starlinkCloud,
    selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
    hasUserChangedServiceLine: state?.authReducer?.hasUserChangedServiceLine,
    newSummaryServiceAccount: state?.authReducer?.newSummaryServiceAccount,

});


export default withRouter(
    connect(mapStateToProps, {
        getUserTerminals,
        downloadAsCSV,
        clearComponentData,
        getAllServiceLines,
        removeTerminalAPI
    })(UserTerminals)
);